import { MessageDescriptor } from 'react-intl';

type ValidationMessage = MessageDescriptor;

const DATE_VALIDATION_ERROR: ValidationMessage = {
  id: 'field_urn_indicates_date',
  description: 'The field definition states this to be an date, but found something else.',
  defaultMessage: 'This value should be a valid ISO 8601 Date (without time component). For instance: 2021-10-31.'
};

const TIME_VALIDATION_ERROR: ValidationMessage = {
  id: 'field_urn_indicates_time',
  description: 'The field definition states this to be a time, but found something else.',
  defaultMessage:
    'This value should be a valid ISO 8601 time (HH, HH:mm, or HH:mm:ss). For instance: 14, 00:00, 23:59:59.'
};

const OBJECT_VALIDATION_ERROR: ValidationMessage = {
  id: 'field_urn_indicates_object',
  description: 'The field definition states this to be an object, but found something else.',
  defaultMessage: 'This value should be a valid JSON object.'
};

const URN_DEFINITION_NOT_FOUND_ERROR: ValidationMessage = {
  id: 'field_urn_not_found',
  description: 'This column is misconfigured, please inform a system admin.',
  defaultMessage: 'This column is misconfigured, please inform a system admin.'
};

const UNALLOWED_VALUE_ERROR: ValidationMessage = {
  id: 'field_urn_indicates_restricted_values',
  description: 'The selected value is invalid for this field.',
  defaultMessage: 'The selected value is invalid for this field.'
};

const BAD_REGULAR_EXPRESSION_IN_DEFINITION_ERROR: ValidationMessage = {
  id: 'field_definition_invalid',
  description: 'The field definition is invalid, bad regular expression provided.',
  defaultMessage: 'The field definition is invalid, bad regular expression provided.'
};

const STRING_DOES_NOT_MATCH_REGEXP_ERROR: ValidationMessage = {
  id: 'field_urn_indicates_unmatched_pattern',
  description: 'The field does not match specified regular expression.',
  defaultMessage: 'This value should comply with the specified format.'
};

const INVALID_PHONE_NUMBER_ERROR: ValidationMessage = {
  id: 'invalid_phone_number',
  description: 'This value should be a valid phone number according to ITU E.164. For instance: +16505551212x123.',
  defaultMessage: 'This value should be a valid phone number according to ITU E.164. For instance: +16505551212x123.'
};

const INVALID_NUMBER_ERROR: ValidationMessage = {
  id: 'invalid_number',
  description: 'This value should be a number.',
  defaultMessage: 'This value should be a number.'
};

const REQUIRED_FIELD_MISSING: ValidationMessage = {
  id: 'missing_required_field',
  description: 'This value is required.',
  defaultMessage: 'This value is required.'
};

export const messages = {
  DATE_VALIDATION_ERROR,
  TIME_VALIDATION_ERROR,
  OBJECT_VALIDATION_ERROR,
  URN_DEFINITION_NOT_FOUND_ERROR,
  UNALLOWED_VALUE_ERROR,
  BAD_REGULAR_EXPRESSION_IN_DEFINITION_ERROR,
  STRING_DOES_NOT_MATCH_REGEXP_ERROR,
  INVALID_PHONE_NUMBER_ERROR,
  INVALID_NUMBER_ERROR,
  REQUIRED_FIELD_MISSING
};
